module.exports = __webpack_public_path__ + "static/media/ur.d7f8e3ac.png";